import { Box, Button, Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { useState } from 'react';
import { TraxxButton } from 'app/components';
import { API } from 'app/services';
import { makeStyles } from '@material-ui/core/styles';
import { useAsyncTask } from 'app/utils';

const useStyles = makeStyles((theme) => ({
  app: {
    padding: theme.spacing(3),
  },
  uploadBox: {
    border: '1px dashed #ccc',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  preview: {
    width: '100%',
    maxHeight: 200,
    objectFit: 'contain',
    marginTop: 10,
  },
  toggle: {
    marginBottom: theme.spacing(2),
  },
}));

const SelectDocument = ({ caseId, caseName, onBack }) => {
  const classes = useStyles();

  const [docType, setDocType] = useState('PASSPORT'); // 🔥 NEW

  const [front, setFront] = useState(null);
  const [back, setBack] = useState(null);
  const [selfie, setSelfie] = useState(null);

  const [runUpload, loading] = useAsyncTask('uploadDoc');

  const handleFile = (e, setter) => {
    const file = e.target.files[0];
    setter(file);
  };

  const handleSubmit = () => {
    // ✅ Validation
    if (!front) {
      alert('Front image required');
      return;
    }

    if (docType === 'IDENTITY' && !back) {
      alert('Back image required for Identity');
      return;
    }

    runUpload(async () => {
      const formData = new FormData();
      formData.append('case_id', caseId);
      formData.append('case_name', caseName);
      formData.append('document_type', docType);

      formData.append('front', front);
      if (back) formData.append('back', back);
      if (selfie) formData.append('selfie', selfie);

      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }
      await API.Screening.upload_document(formData);

      alert('Upload successful');
    });
  };

  return (
    <Box className={classes.app}>
      <Box display="flex">
        <Button onClick={onBack}>Previous</Button>
        <Box flexGrow={1} />
        <TraxxButton loading={loading} onSubmit={handleSubmit}>
          Submit
        </TraxxButton>
      </Box>

      {/* 🔥 TOGGLE */}
      <ToggleButtonGroup value={docType} exclusive onChange={(_, val) => val && setDocType(val)} className={classes.toggle}>
        <ToggleButton value="PASSPORT">Passport</ToggleButton>
        <ToggleButton value="IDENTITY">Identity</ToggleButton>
      </ToggleButtonGroup>

      {/* FRONT */}
      <Box className={classes.uploadBox}>
        <Typography>Upload Front {docType === 'PASSPORT' ? '(Passport)' : '(ID Front)'} *</Typography>
        <input type="file" accept="image/*" onChange={(e) => handleFile(e, setFront)} />
        {front && <img src={URL.createObjectURL(front)} className={classes.preview} />}
      </Box>

      {/* BACK (ONLY FOR IDENTITY) */}
      {docType === 'IDENTITY' && (
        <Box className={classes.uploadBox}>
          <Typography>Upload Back of Identity *</Typography>
          <input type="file" accept="image/*" onChange={(e) => handleFile(e, setBack)} />
          {back && <img src={URL.createObjectURL(back)} className={classes.preview} />}
        </Box>
      )}
    </Box>
  );
};

export default SelectDocument;
